import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import { postRequest } from 'utils/requests';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import {
  SearchField,
  WidgetRelease,
  Loader
} from 'components/common/Elements/Elements';

import imgNotFind from 'assets/svg/notfindrelease.svg';
import classes from './AddOutputs.module.scss';

const AddOutputs = ({ setIsOpen, getData, onOfNotif, mixpanel }) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;

  const [urlInput, setUrlInput] = useState('');
  const [dataForNewArticle, setDataForNewArticle] = useState();

  const [clearableUrl, setClearableUrl] = useState(false);

  const [loaderData, setLoaderData] = useState(false);
  const [notFind, setNotFind] = useState(false);

  const params = useParams();

  const onClear = () => {
    trackingEvent('clear_url_article', mixpanel, username);

    setUrlInput('');
    setDataForNewArticle();
    setNotFind(false);
    setClearableUrl(false);
  };

  const handleUrl = e => {
    setUrlInput(e.target.value);
    setNotFind(false);
    setDataForNewArticle();
    setClearableUrl(false);
  };

  const onSubmitSearh = e => {
    trackingEvent('search_url_article', mixpanel, username);

    e.preventDefault();
    setLoaderData(true);

    const url = `/api/press-releases/action/article-search`;
    const REQ_BODY = {
      url: urlInput
    };
    postRequest(url, REQ_BODY)
      .then(res => {
        setDataForNewArticle(res);
        setClearableUrl(true);
        setLoaderData(false);
      })
      .catch(err => {
        setNotFind(true);
        setDataForNewArticle();
        setClearableUrl(true);
        setLoaderData(false);
      });
  };

  const onAddArticle = () => {
    trackingEvent('add_article', mixpanel, username);

    const url = `/api/press-releases/action/${params.releaseId}/article-add`;
    const REQ_BODY = {
      url: urlInput
    };

    postRequest(url, REQ_BODY)
      .then(() => {
        setLoaderData(false);
        getData();
        setIsOpen();
        onOfNotif('on', t('notif', 'OUTPUT_ADDED', language), false, '2000');
      })
      .catch(err => {
        console.log(err);
        setLoaderData(false);
      });
  };

  return (
    <div>
      <p className={classes.title}>{t('addOutputs', 'ENTER_LINK', language)}</p>
      <SearchField
        value={urlInput}
        onChange={handleUrl}
        onClear={onClear}
        onSubmit={onSubmitSearh}
        className={classes.addContainer}
        isClearabled={clearableUrl}
      />
      {loaderData && <Loader />}
      {dataForNewArticle && (
        <>
          <p className={classes.titleResult}>
            {t('addOutputs', 'FOUND', language)}
          </p>
          <WidgetRelease
            date={dataForNewArticle.date}
            sourse={dataForNewArticle.articleUrl}
            title={dataForNewArticle.articleTitle}
            className={classes.addContainer}
            onClick={onAddArticle}
          />
        </>
      )}

      {notFind && (
        <>
          <p className={classes.subtitle}>
            {t('addOutputs', 'NOT_FOUND', language)}
          </p>
          <div className={classes.notFindWrap}>
            <img src={imgNotFind} alt="logo" width="256" height="228" />
          </div>
        </>
      )}
    </div>
  );
};

AddOutputs.propTypes = {
  setIsOpen: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
  onOfNotif: PropTypes.func,
  mixpanel: PropTypes.object
};

export default AddOutputs;
